import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../state'
import * as errorMessage from '../../error-message'

/**
 * Modal used for creating and editing Admin Center tenants.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.text.Component,
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.input.colorpicker.Component,
    errorMessage.Component,
  ],
  selector: 'atn-admin-tenant-modal',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** Editing tenant */
  public readonly tenantSg = ngCore.computed(() =>
    this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asSignal(),
  )

  /** Editing tenant name*/
  public readonly nameSg = ngCore.computed(
    (tenant = this.tenantSg()) => tenant?.name,
  )

  /** Editing tenant alias*/
  public readonly aliasSg = ngCore.computed(
    (tenant = this.tenantSg()) => tenant?.alias,
  )

  /** Editing tenant code*/
  public readonly codeSg = ngCore.computed(
    (tenant = this.tenantSg()) => tenant?.code,
  )

  /** Editing tenant theme color*/
  public readonly colorSg = ngCore.computed(
    (tenant = this.tenantSg()) => tenant?.color ?? ds.color.Scale.PRIMARY.main,
  )

  /**
   * Shows dialog title based on {@link isNew}
   */
  public readonly titleSg = ngCore.computed(
    (
      isNew = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .isCreating()
        .asSignal(),
    ) => `${isNew ? 'Create' : 'Update'} Tenant`,
  )

  /**
   * Updates a specific property of the currently edited tenant.
   */
  public updateTenant<K extends keyof ents.core.admin.Tenant.Input>(
    prop: K,
    value: ents.core.admin.Tenant.Input[K],
  ): void {
    this.tenantsEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: tenant => {
          if (!tenant) {
            return
          }
          tenant[prop] = value
        },
      })
  }

  /** Submit changes handler */
  public saveClickHandler = () => {
    this.tenantsEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.SaveButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }

  /** Discard changes handler */
  public cancelClickHandler = () => {
    this.tenantsEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }
}
